import { render, staticRenderFns } from "./Stocuri.vue?vue&type=template&id=890dcd9e&scoped=true"
import script from "./Stocuri.vue?vue&type=script&lang=js"
export * from "./Stocuri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890dcd9e",
  null
  
)

export default component.exports